import { useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import ArticleHero from './components/ArticleHero';
import ReaderReview from './components/ReaderReview';
import ContinueReading from './components/ContinueReading';
import { comics } from '@/mocks/data';

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const comicId = parseInt(id || '1', 10);
  const comic = comics.find((c) => c.id === comicId) || comics[0];

  return (
    <>
      <SchemaOrg type="Article" data={{
        headline: comic.title,
        author: { '@type': 'Person', name: comic.author },
        datePublished: comic.updateDate,
        description: comic.description,
        url: `http://pedionline.com/article/${comicId}`,
        isPartOf: { '@type': 'WebSite', name: '韩漫屋', url: 'http://pedionline.com/' },
      }} />
      <SchemaOrg type="WebPage" data={{
        name: `${comic.title} - 韩漫屋`,
        url: `http://pedionline.com/article/${comicId}`,
        description: comic.description,
        isPartOf: { '@type': 'WebSite', name: '韩漫屋', url: 'http://pedionline.com/' },
      }} />
      <SchemaOrg type="BreadcrumbList" data={{
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'http://pedionline.com/' },
          { '@type': 'ListItem', position: 2, name: `${comic.categoryName}漫画`, item: `http://pedionline.com/category/${comic.category}` },
          { '@type': 'ListItem', position: 3, name: comic.title, item: `http://pedionline.com/article/${comicId}` },
        ],
      }} />

      <Navbar />
      <Breadcrumb items={[
        { label: '首页', path: '/' },
        { label: `${comic.categoryName}漫画`, path: `/category/${comic.category}` },
        { label: comic.title },
      ]} />

      <main>
        <ArticleHero comicId={comicId} />
        <ReaderReview />
        <ContinueReading currentId={comicId} />
      </main>

      <Footer />
    </>
  );
}